import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router        from '@/router'
import { useAppStore } from '@/stores/app'

export const useFetchStore = defineStore('fetch', () => {
    const appStore = useAppStore()

    // Cookie-based auth: no Authorization header. The browser attaches the HttpOnly JWT cookie
    // on same-origin requests, so we only need credentials: 'include'.
    const fetch = createFetch({
        baseUrl: '/api/v1',
        fetchOptions: {
            credentials: 'include',
        },
        options: {
            // The API explains a failure in a plain-text body ("reset email already sent");
            // keep it in `data` so a view can tell the cases apart. Views read `data` only
            // after checking the status.
            updateDataOnError: true,
            async onFetchError(ctx) {
                // The portal API answers 401 for a missing session AND for a missing
                // permission; the legacy portal sent both to the login page. A failed sign-in
                // is answered on the login page itself, so it does not navigate.
                if (ctx.response?.status === 401 && router.currentRoute.value.name !== 'login') {
                    appStore.setLogout()
                    await router.push({ name: 'login' })
                }
                return ctx
            },
        },
    })

    return { fetch }
})
